import { z } from 'zod';

import { zodTemporalInstant } from '../Temporal';
import { BaseLoanEvent } from './BaseLoanEvent';

export const PastDueMilestoneEvent = BaseLoanEvent.extend({
  type: z.literal('pastDueMilestone'),
  eventTime: zodTemporalInstant, // override BaseLoanEvent to make this required because this is needed for the ticking service
});
export type PastDueMilestoneEvent = z.infer<typeof PastDueMilestoneEvent>;
